import {useDispatch} from 'react-redux';
import {useCallback} from 'react';
import {toggleModalAction} from 'module/Modal/action/ModalAction';
import {ModalKey} from 'module/Modal/type/ModalKey';

export const useOpenModalCallback = (modalKey: ModalKey) => {
	const dispatch = useDispatch();
	return useCallback(() => dispatch(toggleModalAction({modalKey, open: true})), [dispatch, modalKey])
}